import { render, staticRenderFns } from "./Indications.vue?vue&type=template&id=670afa4b&scoped=true&lang=pug"
import script from "./Indications.vue?vue&type=script&lang=js"
export * from "./Indications.vue?vue&type=script&lang=js"
import style0 from "./Indications.vue?vue&type=style&index=0&id=670afa4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670afa4b",
  null
  
)

export default component.exports